import ActivateCode from "./ActivateCode";

function App() {
  return (
    <>
      <ActivateCode></ActivateCode>
    </>
  );
}

export default App;
